function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';
import Collector from "../../../../services/collector";
import { useWorkFlow } from "../../../contexts/workflow";
import Translate from "../../../common/translation";
import Icon from "../../../common/icon";
import FormList from "./form";
import DndList from "./dnd-list";
import DndService from "./dnd-function";

/**
 * Complex type
 *
 * List of response
 *
 */
var DndListIndex = function DndListIndex(props) {
  var onChange = props.onChange,
    index = props.index,
    elements = props.elements;
  // HOOKS
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentOrder = collector.currentOrder,
    currentQuestion = collector.currentQuestion,
    responses = collector.responses;
  // STATE
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAddMode = _useState2[0],
    setIsAddMode = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isUpdateMode = _useState4[0],
    setIsUpdateMode = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    updateMode = _useState6[0],
    setUpdateMode = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    currentResponse = _useState8[0],
    setCurrentResponse = _useState8[1];

  // UPDATE REDUCER
  var listReducer = function listReducer(state, action) {
    var type = action.type,
      value = action.value;
    if (type === 'all') {
      return value;
    }
    var newState = _objectSpread({}, state);
    if (value) {
      newState[type] = value;
    } else {
      delete newState[type];
    }
    var resp = DndService.reducerValuesToResponseFormat(newState);
    setTimeout(function () {
      return onChange(currentResponse || {}, resp, null, index);
    }, 500);
    return newState;
  };

  // reducer instance and var init
  var _useReducer = useReducer(listReducer, {}),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    listElements = _useReducer2[0],
    dispatch = _useReducer2[1]; // {1: [{<el>}, {<el2>}], 2: ...}
  var isMultiple = Object.keys(listElements).length > 1;
  var updateList = function updateList(element, index) {
    dispatch({
      type: index,
      value: element
    });
  };

  // Valid the creator view (to add an entire list)
  var handleValid = function handleValid(values) {
    updateList(values, Object.keys(listElements).length + 1);
    setIsAddMode(!isAddMode);
  };

  // used whend dynamically updated the list.
  var handleOnChange = function handleOnChange(value, index) {
    updateList(value, index);
  };
  var handleSetUpdateMode = function handleSetUpdateMode(index) {
    setUpdateMode(index);
    setIsUpdateMode(true);
  };

  /**
   * Initialization
   */
  useEffect(function () {
    var historicQuestion = Collector.getCurrentOrderResponses(currentOrder, responses);
    var listResponses = historicQuestion ? historicQuestion.responses : null;
    if (!listResponses) {
      return;
    }
    DndService.responseToDndListFormat(currentQuestion.alias, listResponses, elements, dispatch);
    setCurrentResponse(listResponses);
  }, []);
  useEffect(function () {
    return function () {
      // clean up
      setIsAddMode(false);
      setIsUpdateMode(false);
      setUpdateMode(null);
      setCurrentResponse(null);
    };
  }, []);
  var handleDelete = function handleDelete(key, index) {
    var tmpIndex = {};
    var i = 1;
    Object.keys(listElements[index]).forEach(function (keyIndex) {
      if (key !== keyIndex) {
        tmpIndex[i] = listElements[index][key];
        i++;
      }
    });
    listElements[index] = tmpIndex;
    if (Object.keys(listElements[index]).length === 0) {
      delete listElements[index];
    }
    updateList(listElements[index], index);
  };
  if (isAddMode) {
    return /*#__PURE__*/React.createElement(FormList, {
      items: elements,
      onValid: handleValid,
      create: true
    });
  }
  if (isUpdateMode) {
    return /*#__PURE__*/React.createElement(FormList, {
      items: elements,
      value: listElements,
      index: updateMode,
      onChange: handleOnChange,
      onValid: function onValid() {
        return setIsUpdateMode(false);
      }
    });
  }
  if (!elements || Object.keys(elements).length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "12"
  }, isMultiple ? Object.keys(listElements).map(function (key, index) {
    return listElements[key] && Object.keys(listElements[key]).length > 0 && /*#__PURE__*/React.createElement(DndList, {
      key: "".concat(key, "_").concat(index),
      index: key,
      elements: listElements[key],
      setUpdateMode: function setUpdateMode() {
        return handleSetUpdateMode(key);
      },
      setElements: function setElements(element) {
        return updateList(element, key);
      },
      onDeleteElement: handleDelete
    });
  }) : /*#__PURE__*/React.createElement(FormList, {
    items: elements,
    value: listElements,
    index: "1",
    onChange: handleOnChange
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    className: "text-left"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    color: "default",
    className: "font-weight-bold text-uppercase text-dark-pink background-transparent",
    onClick: function onClick() {
      return setIsAddMode(!isAddMode);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "plus"
  }), " ", /*#__PURE__*/React.createElement(Translate, {
    id: "collector_add_mode"
  }))));
};
DndListIndex.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({}))
};
DndListIndex.defaultProps = {
  elements: []
};
export default DndListIndex;